/** Stock wording and week maths shared by the Worker and the web app. */
import { addDays, weekdayOf } from "./time";
import type { StockCategory, StockColour, StockLevel } from "./types";

export const STOCK_CATEGORIES: StockCategory[] = ["waste", "chemicals", "consumables"];

/** Short group headings on the cleaner's screen. */
export const STOCK_CATEGORY_SHORT: Record<StockCategory, string> = {
  waste: "Bin bags",
  chemicals: "Cleaning products",
  consumables: "Rolls & cloths",
};

/** Full headings for the office. */
export const STOCK_CATEGORY_TITLE: Record<StockCategory, string> = {
  waste: "Waste management & liners",
  chemicals: "Cleaning chemicals & solutions",
  consumables: "Consumables & laundry",
};

export const STOCK_LEVEL_LABEL: Record<StockLevel, string> = {
  low: "Running low",
  out: "Run out",
  collect: "Needs collecting",
};

export const STOCK_COLOURS: StockColour[] = ["black", "white", "red", "blue", "green", "yellow"];

/** The Friday of the Monday–Sunday week that `date` (YYYY-MM-DD) falls in. */
export function stockWeek(date: string): string {
  const fromMonday = (weekdayOf(date) + 6) % 7; // Monday 0 … Sunday 6
  return addDays(date, 4 - fromMonday);
}

export const isFriday = (date: string) => weekdayOf(date) === 5;
